import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { ProfessionalCategoryListComponent } from './professional-category-types-list/professional-category-list.component';
import { ProfessionalCategoryDetailComponent } from './professional-category-types-detail/professional-category-detail.component';

const routes: Routes = [
    {
        path: 'professional-categories',
        children: [
            { path: '', component: ProfessionalCategoryListComponent }
        ]
    },
    {
        path: 'professional-categories/:id',
        children: [
            { path: '', component: ProfessionalCategoryDetailComponent }
        ]
    },
];

@NgModule({
    imports: [RouterModule.forChild(routes)],
    exports: [RouterModule]
})
export class ProfessionalCategoryRoutingModule { }
